define('controller/disclosure/disclosure.auto.approval.controller',['require','exports','module','fukit','view/disclosure/disclosure.auto.approval.view','model/campaign-manager.model','model/reviewer.unit.assignment.model','model/primary.reviewer.unit.assignment.model','underscore','backbone.radio','fukit'],function(require, exports, module) {
  //prettier-ignore
  var BaseController = require('fukit').BaseController,
        DisclosureAutoApprovalPageView = require('view/disclosure/disclosure.auto.approval.view'),
        CampaignManagerModel           = require('model/campaign-manager.model'),
        ReviewerUnitAssignmentModel    = require('model/reviewer.unit.assignment.model'),
        PrimaryReviewerUnitAssignmentModel    = require('model/primary.reviewer.unit.assignment.model'),
        _                             = require('underscore'),
        Radio                         = require('backbone.radio'),
        ROLES                          = require('fukit').Roles;

  
  var  coiModel;
  var  productNewCoiUiValue = false;
  const enabledProductCollection =   Radio.request(
      'AppKit.resourceService',
      'resource',
      'enabledProductCollection'
  );

  if (!_.isUndefined(enabledProductCollection)) {
    coiModel = enabledProductCollection.findWhere({name: 'COI', active: true});
    const dataModel = coiModel.collection.models;
    const filteredDataArray = dataModel.filter(function (item) {
      return item.attributes.name === "COI" && item.attributes.active === true;
    });
    productNewCoiUiValue = filteredDataArray[0].attributes.productNewCoiUi;
  }

  if(productNewCoiUiValue){
    localStorage.setItem("productNewCoiUiValue", productNewCoiUiValue.toString());
    location.assign(location.origin + '/coi-react/disclosure/approvals');
  }

  var DisclosureAutoApprovalController = BaseController.extend({
    radioRequests: {
      'controllers DisclosureAutoApprovalController': '@constructor',
    },

    pageView: DisclosureAutoApprovalPageView,

    stateConfiguration: {
      defaults: {
        roles: ROLES.GLOBALACCESSROLES,
      },
    },

    resources: {
      campaignManagerModel: {
        fetchOnStart: true,
        fetchWhenNew: true,
        model: CampaignManagerModel,
      },

      checkBoxGroupModel: {
        required: false,
        model: Backbone.Model,
        data: {
          label_1: 'Manually approve all disclosures',
          selected_1: false,
          label_2: 'Automatically approve disclosures that report no external relationships',
          selected_2: false,
          label_3: 'Manually approve all disclosures',
          selected_3: false,
          label_4: 'Automatically approve disclosures that report no external relationships',
          selected_4: false,
          selected_5: false,
          selected_6: false,
        },
      },

      primaryReviewerUnitAssignmentModel: {
        model: PrimaryReviewerUnitAssignmentModel,
        required: false,
      },

      reviewerUnitAssignmentModel: {
        model: ReviewerUnitAssignmentModel,
        required: false,
      },

      // Utility resource
      uiState: {
        model: Backbone.Model.extend({
          defaults: {
            fileActionSuccess: false,
            fileActionNotify: false,
          },
        }),
      },
    },


      initialize: function() {

          this.listenTo(this.getResource('reviewerUnitAssignmentModel'), 'error', function(reviewerUnitAssignmentModel, error) {

              var uiStateResource = this.getResource('uiState');

              uiStateResource.set({
                  fileActionSuccess: false,
                  fileActionNotify: true,
              });

              console.log('END handling error for reviewerUnitAssignmentModel at controller');

          });


          this.listenTo(this.getResource('primaryReviewerUnitAssignmentModel'), 'error', function(primaryReviewerUnitAssignmentModel, error) {

              var uiStateResource = this.getResource('uiState');

              uiStateResource.set({
                  fileActionSuccess: false,
                  fileActionNotify: true,
              });

              console.log('END handling error for primaryReviewerUnitAssignmentModel at controller');

          });


      },


  });

  module.exports = DisclosureAutoApprovalController;
});

